const handleHtmlContentClick = (event) => {
    const code = event?.code;
    const target = event?.target;
    const type = event?.type;

    // Check if element is clicked or using accepted keyboard event
    const shouldIntercept =
        type === 'click' || code === 'Enter' || code === 'Space';

    // Intercept link clicks and check to see if the
    // destination is internal to avoid refreshing the page
    if (target?.tagName === 'A' && shouldIntercept) {
        event.preventDefault();
        const { search: query, target: tabTarget, href } = target;

        if (tabTarget && globalThis.open) {
            if (query) {
                globalThis.open(href + query);
            } else {
                globalThis.open(href);
            }
        } else {
            globalThis.location.assign(href);
        }
    }
};

export default handleHtmlContentClick;
